"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELECT = void 0;
const vue_1 = __importDefault(require("vue"));
const lodash_1 = require("lodash");
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const text_1 = require("./text");
const SELECT_FORMATTER_CONFIG = text_1.TEXT.formatter.schema.extend({
    options: z.array(z.any()),
    bindObject: z
        .boolean()
        .optional()
        .default(false),
    valueField: z
        .string()
        .optional()
        .default('id'),
    textField: z
        .string()
        .optional()
        .default('text')
});
const SELECT_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({
    placeholder: z.string().optional(),
    multiple: z
        .boolean()
        .optional()
        .default(false),
    options: z.array(z.any()),
    bindObject: z
        .boolean()
        .optional()
        .default(false),
    valueField: z
        .string()
        .optional()
        .default('id'),
    textField: z
        .string()
        .optional()
        .default('text')
});
exports.SELECT = {
    name: 'select',
    formatter: {
        schema: SELECT_FORMATTER_CONFIG,
        createComponent(config) {
            const valueMap = (0, lodash_1.reduce)(config.options, (m, opt) => {
                m[(0, lodash_1.get)(opt, config.valueField)] = (0, lodash_1.get)(opt, config.textField);
                return m;
            }, {});
            return text_1.TEXT.formatter.createComponent({ ...config, valueMap });
        }
    },
    editor: {
        schema: SELECT_EDITOR_CONFIG,
        createComponent(config) {
            function getOption(item) {
                if ((0, lodash_1.isString)(item)) {
                    return { value: item, [config.textField]: item };
                }
                return {
                    ...item,
                    value: config.bindObject
                        ? item
                        : (0, lodash_1.get)(item, config.valueField, '#error')
                };
            }
            return {
                component: {
                    name: 'Select2Editor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<b-form-select
              v-model="currentValue"
              v-bind="bindings"
              :autofocus="autofocus"
              :id="col.field"
              :tabindex="col.effectiveTabindex"
              :size="col.size"
              :form="formId"
              :disabled="isDisabled"
              :state="validationState"
              @change="onChange($event)"
            >
            </b-form-select>`),
                    data() {
                        return {
                            bindings: {
                                multiple: config.multiple,
                                options: config.options.map(getOption),
                                valueField: 'value',
                                textField: config.textField
                            }
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=select.js.map